class AllstoraAlgoliaClass {
  constructor() {
    this.lastPos = null;

    this.config = {
      perPageScroll: 12,
      resultsDisplayLimit: 200000,
    };

    this.html = {
      brandSymbol: `
        <svg width="87" height="60" viewBox="0 0 87 60" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M85.9203 29.1826L85.929 29.1739C85.2584 25.9627 83.4802 23.1665 80.9746 21.0672C79.6159 19.9269 78.1872 18.8347 76.5969 18.0373C75.8061 17.642 74.9738 17.3165 74.111 17.1264C72.5425 16.7813 70.7687 16.6982 69.1609 16.7922C67.6077 16.8861 66.0851 17.275 64.7307 18.0439C64.1824 18.3519 63.6975 18.8391 63.2934 19.3327C62.3081 20.543 62.4501 22.3189 63.5031 23.3063C64.4708 24.2129 66.8126 24.285 67.6034 23.2124C67.9245 22.7755 68.2325 22.45 68.7611 22.0524C70.3951 20.8095 71.8981 20.0711 73.8466 20.2328C79.7469 20.7155 85.6298 25.8775 84.437 33.3135C83.963 36.2626 82.4404 38.2548 79.5875 39.1111C76.9726 39.8932 74.3207 39.7031 71.7058 39.0194C67.6317 37.9533 63.8154 36.2429 60.0297 34.4538V0H59.2455C57.1287 2.11677 55.1168 2.27406 51.9012 2.27406C49.8107 10.1928 46.5601 18.9308 43.6002 26.3887L42.6936 26.037C40.2885 25.0124 37.8877 23.9748 35.4389 23.0595C30.3949 21.1808 24.9184 19.9138 19.5096 20.4774C14.0986 21.041 9.44345 23.8284 5.90457 28.0707C2.52954 32.1317 0.585337 36.7956 0.104749 42.0362C-0.109331 44.3998 -0.0197668 46.8071 0.602813 49.1095C0.96107 50.4355 1.40234 51.7528 2.04895 52.9674C4.63102 57.806 10.2299 59.9512 15.4552 59.9992C20.8487 60.0495 25.2264 57.6225 29.0558 54.0662C34.9059 48.6311 38.7309 41.8243 42.0666 34.6985C42.7832 33.1715 43.4625 31.6271 44.1834 30.0258C46.5645 31.437 48.8517 32.8264 51.1825 34.1545L51.9034 34.5674V51.4775C51.7265 57.0458 51.3813 57.0458 47.2242 57.83V58.6143H64.7176V57.8584C61.4649 57.1419 60.1105 57.7077 60.0297 51.4775V39.1788C60.4382 39.3907 60.8467 39.6026 61.2574 39.808C62.496 40.4306 63.7477 41.0269 65.0257 41.5709C67.5706 42.65 70.2269 43.526 72.9728 43.8973C74.1918 44.0612 75.3976 44.1486 76.6253 43.9541C78.1042 43.7204 79.037 43.2748 80.0834 42.6085C84.7363 39.6485 86.9383 34.0431 85.9225 29.1804L85.9203 29.1826ZM39.3557 35.2883L39.3601 35.2839C37.3787 39.0915 35.12 42.7199 32.2321 45.9311C29.0995 49.4132 25.4995 52.2596 20.8552 53.354C16.4906 54.3829 12.1391 54.5773 8.2398 51.72C5.72763 49.8785 4.44752 47.2811 4.03246 44.2927C2.87468 35.9502 7.37255 27.4066 14.9484 23.6515C18.6742 21.9097 22.7885 21.5019 26.9172 22.4456C31.8782 23.5772 36.3913 25.7857 40.8259 28.1778C41.2999 28.4333 41.7696 28.6933 42.3615 29.0188C41.3458 31.1487 40.413 33.2523 39.3557 35.2905V35.2883ZM51.6784 30.3404C49.4764 29.246 47.4077 28.2149 45.5356 27.2843C47.7856 21.0148 49.6119 16.2548 51.9012 9.05472V30.4496L51.6784 30.3382V30.3404Z" fill="currentColor"/>
        </svg>
      `,
    };

    this.isCollection = window.location.href.includes('/collection');
    this.isSearch = window.location.href.includes('/search');

    this.init();
  }

  init() {
    document.addEventListener('algolia.instantSearch.onRender', (e) => {
      console.log('algolia.instantSearch.onRender');
      this.onRender();
      this.trackQueryChange();

      // wishlist buttons
      document.dispatchEvent(new CustomEvent('swym:collections-loaded'));
    });

    document.addEventListener('algolia.hooks.initialize', (e) => {
      this.registerHooks();
    });
  }

  trackQueryChange() {
    if (!window.location.href.includes('search')) {
      return;
    }

    const searchHeading = document.querySelector('[data-search-page-heading]');
    if (searchHeading) {
      setInterval(() => {
        const searchParams = new URLSearchParams(window.location.search);
        const query = searchParams.get('q');
        if (query !== null) {
          searchHeading.textContent = `Search Results for "${query}"`;
        } else {
          searchHeading.textContent = 'Search';
        }
      }, 1000);
    }
  }

  onRender() {
    // close facet groups on page load
    const facetDropdowns = document.querySelectorAll('.ais-facet-dropdown-wrapper');
    facetDropdowns.forEach((el) => {
      if (Number(el.dataset.index) > 3) {
        el.querySelector('.ais-dropdown-checkbox').setAttribute('checked', 'checked');
      }
    });

    // duplicate sort select for mobile
    /*const sort = document.querySelector('.ais-sort');
    const sortMobile = document.querySelector('.ais-sort--mobile');
    const mobileUtilities = document.querySelector('.ais-utility-mobile');
    const sortCloned = sort.cloneNode(true);
    sortCloned.classList.add('ais-sort--mobile');

    if (!sortMobile) {
      mobileUtilities.appendChild(sortCloned);
    }*/

    this.insertModules();
    this.lazyLoading();
    this.events();
    this.preserveScroll();
  }

  preserveScroll() {
    // Tracking last clicked item
    const hits = document.querySelectorAll('.ais-Hits-item');
    hits.forEach((item, index) => {
      item.addEventListener('click', (e) => {
        const url = new URL(window.location);
        url.searchParams.set('lastpos', index);
        window.history.replaceState(null, '', url.toString());
      });
    });

    // go back to previous scroll position
    const urlParams = new URLSearchParams(window.location.search);
    const lastPos = urlParams.get('lastpos');
    if (lastPos !== null) {
      this.lastPos = lastPos;
    }

    if (this.lastPos !== null) {
      const plpModules = document.querySelectorAll('.plp-module');
      const lastItemIndex = Number(this.lastPos) + plpModules.length + 1;
      const lastItem = document.querySelector(`.ais-Hits-item:nth-child(${lastItemIndex})`);

      if (lastItem) {
        this.getHitsBefore(lastItem).forEach((hit) => {
          this.loadHit(hit);
        });

        this.loadHit(lastItem);

        setTimeout(() => {
          window.scrollTo({
            top: lastItem.getBoundingClientRect().top + window.scrollY - 60,
          });
        }, 100);

        setTimeout(() => {
          window.scrollTo({
            top: lastItem.getBoundingClientRect().top + window.scrollY - 60,
          });
        }, 200);
      }
    }
  }

  events() {
    const closeEls = document.querySelectorAll('[data-ais-mobile-drawer-close]');
    closeEls.forEach((el) => {
      el.addEventListener('click', (e) => {
        e.preventDefault();
        const facets = document.querySelector('.ais-facets');
        facets.classList.remove('ais-facets__shown');
      });
    });

    const openEls = document.querySelectorAll('[data-ais-mobile-drawer-open]');
    openEls.forEach((el) => {
      el.addEventListener('click', (e) => {
        e.preventDefault();
        const facets = document.querySelector('.ais-facets');
        facets.classList.add('ais-facets__shown');
      });
    });

    // pseudo clear buttons for Algolia
    const clearEls = document.querySelectorAll('[data-ais-clear-facets]');
    clearEls.forEach((el) => {
      el.addEventListener('click', (e) => {
        e.preventDefault();
        const clearButton = document.querySelector('.ais-ClearRefinements-button');
        clearButton.dispatchEvent(new Event('click'));
      });
    });
  }

  insertModules() {
    const oldMembershipEl = document.querySelector('.plp-module--membership');
    const oldImageEl = document.querySelector('.plp-module--image');

    if (oldMembershipEl) {
      oldMembershipEl.remove();
    }

    if (oldImageEl) {
      oldImageEl.remove();
    }

    const tileBeforeMembership = document.querySelector('li.ais-Hits-item:nth-child(6)');
    const tileBeforeImage = document.querySelector('li.ais-Hits-item:nth-child(12)');

    if (window.algoliaAllstora.modules.membership && tileBeforeMembership) {
      const membershipEl = document.createElement('li');
      membershipEl.classList.add('plp-module', 'plp-module--membership');
      membershipEl.innerHTML = window.algoliaAllstora.modules.membership;
      tileBeforeMembership.after(membershipEl);
    }

    if (window.algoliaAllstora.modules.image && tileBeforeImage) {
      const imageEl = document.createElement('li');
      imageEl.classList.add('plp-module', 'plp-module--image');
      imageEl.innerHTML = window.algoliaAllstora.modules.image;
      tileBeforeImage.after(imageEl);
    }
  }

  lazyLoading() {
    let observer = new IntersectionObserver(
      (entries, observer) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.loadHit(entry.target);
            observer.unobserve(entry.target);
          }
        });
      },
      { rootMargin: '0px 0px 0px 0px' }
    );

    const hits = document.querySelectorAll('.ais-Hits-item');
    hits.forEach((item, index) => {
      const template = item.querySelector('template');
      if (template) {
        item.classList.add('ais-lazy');
        observer.observe(item);
      }
    });
  }

  getHitsBefore(hit, array = []) {
    const previous = hit.previousElementSibling;
    if (!previous) {
      return array.reverse();
    }
    array.push(previous);
    return this.getHitsBefore(previous, array);
  }

  loadHit(hit) {
    const template = hit.querySelector('template');
    if (template) {
      hit.innerHTML = template.innerHTML;
    }
    hit.classList.remove('ais-lazy');
  }

  renderBadge(hit, html) {
    const namedTags = Object.entries(hit.named_tags).map(([key, value]) => {
      return `${key}:${value}`;
    });

    const namedTagBadgesMatch = namedTags.find((namedTag) => {
      return Object.keys(window.algoliaAllstora.badges).find((badgeKey) => {
        return badgeKey === namedTag;
      });
    });

    const badgeUrl = window.algoliaAllstora.badges[namedTagBadgesMatch];

    if (badgeUrl) {
      return html`
        <img
          src="${badgeUrl}"
          class="brand-product-tile__badge"
          width="320"
          height="320"
          alt="${namedTagBadgesMatch.split(':')[1]}"
          loading="lazy"
        />
      `;
    }

    return '';
  }

  renderMemberPrice(hit, html) {
    const memberDiscount = window.algoliaAllstora.isMember
      ? window.algoliaAllstora.memberDiscount
      : window.algoliaAllstora.newMemberDiscount;
    if (hit.compare_at_price > 0) {
      return html`
        <s
          class="brand-product-tile__compare-at-price"
          aria-label="${window.algoliaAllstora.translate['allstora.user.member.old_price']}"
        >
          $${(hit.compare_at_price * (1.0 - memberDiscount)).toFixed(2)}
        </s>
        $${(hit.price * (1.0 - memberDiscount)).toFixed(2)}
      `;
    }

    return html`$${(hit.price * (1.0 - memberDiscount)).toFixed(2)}`;
  }

  renderPrice(hit, html) {
    if (hit.compare_at_price > 0) {
      return html`
        <s
          class="brand-product-tile__compare-at-price"
          aria-label="${window.algoliaAllstora.translate['allstora.user.regular.old_price']}"
        >
          $${hit.compare_at_price.toFixed(2)}
        </s>
        $${hit.price.toFixed(2)}
      `;
    }

    return html`$${hit.price.toFixed(2)}`;
  }

  registerHooks() {
    algoliaShopify.hooks.registerHook('beforeInstantSearchConfigurationOptions', (options) => {
      algoliaShopify.translations['noResultFound'] = 'No result found.';
      algoliaShopify.translations['changeInput'] = 'changing your input.';
      return options;
    });

    algoliaShopify.hooks.registerHook('beforeInstantSearchOptions', (options) => {
      return options;
    });

    // Main Template
    algoliaShopify.hooks.registerHook('beforeInstantSearchMainTemplate', (defaultTemplate, data, html) => {
      return this.instantSearchMainTemplate(data, html);
    });

    // Stats Template
    algoliaShopify.hooks.registerHook('beforeInstantSearchStatsTemplate', (...params) => {
      let data = {};
      params.forEach((item) => {
        if (item.hasOwnProperty('nbHits')) {
          data = item;
        }
      });

      return this.instantSearchStatsTemplate(data);
    });

    // Product Template
    algoliaShopify.hooks.registerHook('beforeInstantSearchProductTemplate', (defaultTemplate, hit, html) => {
      return this.instantSearchProductTemplate(hit, html);
    });

    algoliaShopify.hooks.registerHook('beforeInstantSearchNoResultTemplate', (defaultTemplate, html) => {
      // Default Template
      /**
        <div class="ais-hit-empty">
          <div class="ais-hit-empty--title">${algolia.translations.noResultFound}</div>
          <div class="ais-hit-empty--clears">
            ${algolia.translations.try} ${' '}
            <a class="ais-hit-empty--clear-filters ais-link"> ${algolia.translations.clearFilters} ${' '} </a>
            ${algolia.translations.or} ${' '}
            <a class="ais-hit-empty--clear-input ais-link"> ${algolia.translations.changeInput} </a>
          </div>
        </div>
       */

      let template = `
        <div class="ais-hit-empty">
          <div class="ais-hit-empty--title">${algoliaAllstora.noResultsText}</div>
          <ol class="ais-Hits-list">
      `;

      template += algoliaAllstora.modules.noResultProducts;
      template += '</ol></div>';

      return template;
    });

    algoliaShopify.hooks.registerHook(
      'beforeAutocompleteProductTemplate',
      (_defaultTemplate, templateOptions, _distinct, _itemLink) => {
        const html = templateOptions.html;
        if (templateOptions.item.image === null && templateOptions.item.product_image === null) {
          const title_overlay_div = `<div class="title_overlay font-body-1" style="
            color: white;
            position: absolute;
            top: 55%;
            text-align: center;
            padding: 0 2rem;
          ">${templateOptions.item.title}</div>`;
          templateOptions.item.image = 'https://allstora-assets-prod.s3.us-west-2.amazonaws.com/no_cover.png';
        }

        const template = html`
          <a
            class="brand-product-tile"
            href="${algoliaShopify.helpers.instantsearchLink(templateOptions.item)}"
            aria-label="${templateOptions.item.title}"
          >
            <article class="brand-product-tile__content">
              <div class="brand-product-tile__badge-wrapper">
                ${html`${this.renderBadge(templateOptions.item, html)}`}
              </div>
              <div class="brand-product-tile__image-wrapper">
                <div class="brand-product-image">
                  <img
                    src="${algoliaShopify.helpers.sizedImage('960x', templateOptions.item)}"
                    class="brand-product-image__image"
                    alt=""
                    loading="lazy"
                  />
                  ${title_overlay_div}
                </div>
              </div>
              <div class="brand-product-tile__details">
                ${this.renderAutocompletePrices(templateOptions.item, html)}
              </div>
            </article>
          </a>
        `;

        return html`${template}`;
      }
    );
  }

  renderAutocompletePrices(hit, html) {
    if (window.Shopify.country !== 'US') {
      return '';
    }

    const regular = html` <div
        class="brand-product-tile__member-price font-body-1"
        aria-label="${window.algoliaAllstora.translate['allstora.user.member.price']}"
      >
        ${html`${this.renderMemberPrice(hit, html)}`}
        <span aria-hidden="true"> ${window.algoliaAllstora.translate['allstora.user.member.label']} </span>
      </div>
      <div
        class="brand-product-tile__price font-body-1"
        aria-label="${window.algoliaAllstora.translate['allstora.user.regular.price']}"
      >
        ${html`${this.renderPrice(hit, html)}`}
        <span aria-hidden="true"> ${window.algoliaAllstora.translate['allstora.user.regular.label']} </span>
      </div>`;

    const flagged = html` <div
      class="brand-product-tile__member-price font-body-1"
      aria-label="${window.algoliaAllstora.translate['allstora.user.regular.price']}"
    >
      ${html`${this.renderPrice(hit, html)}`}
      <span aria-hidden="true"> ${window.algoliaAllstora.translate['allstora.user.regular.label']} </span>
    </div>`;
    return hit.product_type === 'FlaggedBook' ? flagged : regular;
  }

  backToAllBooksLinkTemplate(html) {
    if (window.algoliaAllstora.isShopAllCollectionPage || !window.algoliaAllstora.shopAllCollectionPathname) {
      return html``;
    }

    const template = html`
      <a href="${window.algoliaAllstora.shopAllCollectionPathname}" class="ais-facets-back-to-all-books-link">
        ${window.algoliaAllstora.translate['allstora.algolia.back_to_all_books.label'] || 'Back to All Books'}
      </a>
    `;

    return template;
  }

  instantSearchMainTemplate(data, html) {
    const hasBackToAllBooksLink =
      !window.algoliaAllstora.isShopAllCollectionPage && window.algoliaAllstora.shopAllCollectionPathname;

    const template = html`
      <div class="ais-page">
        <div class="ais-hero">
          <h1 class="ais-hero__heading" data-search-page-heading>${window.algoliaAllstora.heading}</h1>
          <div class="ais-hero__symbol">
            <svg width="87" height="60" viewBox="0 0 87 60" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M85.9203 29.1826L85.929 29.1739C85.2584 25.9627 83.4802 23.1665 80.9746 21.0672C79.6159 19.9269 78.1872 18.8347 76.5969 18.0373C75.8061 17.642 74.9738 17.3165 74.111 17.1264C72.5425 16.7813 70.7687 16.6982 69.1609 16.7922C67.6077 16.8861 66.0851 17.275 64.7307 18.0439C64.1824 18.3519 63.6975 18.8391 63.2934 19.3327C62.3081 20.543 62.4501 22.3189 63.5031 23.3063C64.4708 24.2129 66.8126 24.285 67.6034 23.2124C67.9245 22.7755 68.2325 22.45 68.7611 22.0524C70.3951 20.8095 71.8981 20.0711 73.8466 20.2328C79.7469 20.7155 85.6298 25.8775 84.437 33.3135C83.963 36.2626 82.4404 38.2548 79.5875 39.1111C76.9726 39.8932 74.3207 39.7031 71.7058 39.0194C67.6317 37.9533 63.8154 36.2429 60.0297 34.4538V0H59.2455C57.1287 2.11677 55.1168 2.27406 51.9012 2.27406C49.8107 10.1928 46.5601 18.9308 43.6002 26.3887L42.6936 26.037C40.2885 25.0124 37.8877 23.9748 35.4389 23.0595C30.3949 21.1808 24.9184 19.9138 19.5096 20.4774C14.0986 21.041 9.44345 23.8284 5.90457 28.0707C2.52954 32.1317 0.585337 36.7956 0.104749 42.0362C-0.109331 44.3998 -0.0197668 46.8071 0.602813 49.1095C0.96107 50.4355 1.40234 51.7528 2.04895 52.9674C4.63102 57.806 10.2299 59.9512 15.4552 59.9992C20.8487 60.0495 25.2264 57.6225 29.0558 54.0662C34.9059 48.6311 38.7309 41.8243 42.0666 34.6985C42.7832 33.1715 43.4625 31.6271 44.1834 30.0258C46.5645 31.437 48.8517 32.8264 51.1825 34.1545L51.9034 34.5674V51.4775C51.7265 57.0458 51.3813 57.0458 47.2242 57.83V58.6143H64.7176V57.8584C61.4649 57.1419 60.1105 57.7077 60.0297 51.4775V39.1788C60.4382 39.3907 60.8467 39.6026 61.2574 39.808C62.496 40.4306 63.7477 41.0269 65.0257 41.5709C67.5706 42.65 70.2269 43.526 72.9728 43.8973C74.1918 44.0612 75.3976 44.1486 76.6253 43.9541C78.1042 43.7204 79.037 43.2748 80.0834 42.6085C84.7363 39.6485 86.9383 34.0431 85.9225 29.1804L85.9203 29.1826ZM39.3557 35.2883L39.3601 35.2839C37.3787 39.0915 35.12 42.7199 32.2321 45.9311C29.0995 49.4132 25.4995 52.2596 20.8552 53.354C16.4906 54.3829 12.1391 54.5773 8.2398 51.72C5.72763 49.8785 4.44752 47.2811 4.03246 44.2927C2.87468 35.9502 7.37255 27.4066 14.9484 23.6515C18.6742 21.9097 22.7885 21.5019 26.9172 22.4456C31.8782 23.5772 36.3913 25.7857 40.8259 28.1778C41.2999 28.4333 41.7696 28.6933 42.3615 29.0188C41.3458 31.1487 40.413 33.2523 39.3557 35.2905V35.2883ZM51.6784 30.3404C49.4764 29.246 47.4077 28.2149 45.5356 27.2843C47.7856 21.0148 49.6119 16.2548 51.9012 9.05472V30.4496L51.6784 30.3382V30.3404Z"
                fill="currentColor"
              />
            </svg>
          </div>
        </div>

        <div class="ais-input">
          <div class="ais-search-box-container"></div>
          <div class="ais-input-button">
            <div class="ais-clear-input-icon"></div>
          </div>
        </div>
        <div class="ais-utility-mobile">
          <div class="ais-facets-button--open" data-ais-mobile-drawer-open>
            Filter Books
            <svg width="19" height="18" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M7.25 12.6306C7.25 12.4814 7.30926 12.3384 7.41475 12.2329C7.52024 12.1274 7.66332 12.0681 7.8125 12.0681H11.1875C11.3367 12.0681 11.4798 12.1274 11.5852 12.2329C11.6907 12.3384 11.75 12.4814 11.75 12.6306C11.75 12.7798 11.6907 12.9229 11.5852 13.0284C11.4798 13.1339 11.3367 13.1931 11.1875 13.1931H7.8125C7.66332 13.1931 7.52024 13.1339 7.41475 13.0284C7.30926 12.9229 7.25 12.7798 7.25 12.6306ZM5 9.25562C5 9.10643 5.05926 8.96336 5.16475 8.85787C5.27024 8.75238 5.41332 8.69312 5.5625 8.69312H13.4375C13.5867 8.69312 13.7298 8.75238 13.8352 8.85787C13.9407 8.96336 14 9.10643 14 9.25562C14 9.4048 13.9407 9.54787 13.8352 9.65336C13.7298 9.75885 13.5867 9.81812 13.4375 9.81812H5.5625C5.41332 9.81812 5.27024 9.75885 5.16475 9.65336C5.05926 9.54787 5 9.4048 5 9.25562ZM2.75 5.88062C2.75 5.73143 2.80926 5.58836 2.91475 5.48287C3.02024 5.37738 3.16332 5.31812 3.3125 5.31812H15.6875C15.8367 5.31812 15.9798 5.37738 16.0852 5.48287C16.1907 5.58836 16.25 5.73143 16.25 5.88062C16.25 6.0298 16.1907 6.17287 16.0852 6.27836C15.9798 6.38385 15.8367 6.44312 15.6875 6.44312H3.3125C3.16332 6.44312 3.02024 6.38385 2.91475 6.27836C2.80926 6.17287 2.75 6.0298 2.75 5.88062Z"
                fill="#221F1F"
              />
            </svg>
          </div>
          <div class="ais-facets-button"></div>
          <div class="ais-sort">
            ${data.multipleSortOrders
              ? html`
                  <span class="ais-sort-label">Sort By:</span>
                  <span class="ais-sort-orders-container">
                    <span class="ais-sort-orders-container__icon-wrapper">
                      <svg
                        class="ais-sort-orders-container__icon"
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M8.47221 10.4715C8.34719 10.5965 8.17766 10.6667 8.00088 10.6667C7.8241 10.6667 7.65456 10.5965 7.52955 10.4715L3.75821 6.70015C3.69454 6.63865 3.64375 6.56509 3.60881 6.48375C3.57387 6.40241 3.55548 6.31493 3.55471 6.22641C3.55394 6.1379 3.57081 6.05011 3.60433 5.96818C3.63785 5.88625 3.68735 5.81181 3.74995 5.74922C3.81254 5.68662 3.88698 5.63712 3.96891 5.6036C4.05084 5.57008 4.13863 5.55321 4.22715 5.55398C4.31567 5.55475 4.40315 5.57314 4.48448 5.60808C4.56582 5.64302 4.63938 5.69381 4.70088 5.75748L8.00088 9.05748L11.3009 5.75748C11.4266 5.63604 11.595 5.56885 11.7698 5.57036C11.9446 5.57188 12.1118 5.642 12.2354 5.7656C12.359 5.88921 12.4291 6.05642 12.4307 6.23121C12.4322 6.40601 12.365 6.57441 12.2435 6.70015L8.47221 10.4715Z"
                          fill="currentcolor"
                        />
                      </svg>
                    </span>
                  </span>
                `
              : html` ${algoliaShopify.translations.sortBy} ${algoliaShopify.translations.relevance} `}
          </div>
        </div>
        <div class="ais-facets ${hasBackToAllBooksLink ? 'ais-facets--with-back-to-all-books-link' : ''}">
          <div class="ais-facets__back-to-all-books-link">${this.backToAllBooksLinkTemplate(html)}</div>
          <div class="ais-facets-mobile__header">
            <h3 class="ais-facets-mobile__heading">Filters</h3>
            <button type="button" class="ais-facets-mobile__close" data-ais-mobile-drawer-close>
              <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M1.84073 1.84091L16.1589 16.1591"
                  stroke="#211E1E"
                  stroke-width="1.5"
                  stroke-linecap="square"
                />
                <path
                  d="M16.1591 1.84098L1.84092 16.1592"
                  stroke="#211E1E"
                  stroke-width="1.5"
                  stroke-linecap="square"
                />
              </svg>
            </button>
          </div>

          <div class="ais-clear-refinements-container"></div>
          <div class="ais-current-refined-values-container"></div>
          ${data.facets.map((facet, index) => {
            let checked = '';
            if (index > 2) {
              checked = 'checked="checked"';
            }

            return html`
              <div
                class="ais-facet-dropdown-wrapper ais-facet-${facet.type} ais-facet-${facet.escapedName}"
                data-index="${index}"
              >
                <label for="${facet.escapedName}" class="ais-range-slider--header ais-facet--header ais-header">
                  ${facet.title}
                  <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M10.3517 14.3981C10.5236 14.5699 10.7567 14.6665 10.9998 14.6665C11.2428 14.6665 11.4759 14.5699 11.6478 14.3981L16.8334 9.21249C16.921 9.12793 16.9908 9.02678 17.0389 8.91494C17.0869 8.80311 17.1122 8.68282 17.1132 8.56111C17.1143 8.43939 17.0911 8.31869 17.045 8.20603C16.9989 8.09338 16.9309 7.99103 16.8448 7.90496C16.7587 7.81889 16.6564 7.75083 16.5437 7.70474C16.4311 7.65864 16.3104 7.63545 16.1886 7.63651C16.0669 7.63757 15.9467 7.66285 15.8348 7.7109C15.723 7.75894 15.6218 7.82877 15.5373 7.91632L10.9998 12.4538L6.46227 7.91632C6.28938 7.74934 6.05783 7.65695 5.81748 7.65904C5.57714 7.66112 5.34722 7.75753 5.17727 7.92749C5.00731 8.09744 4.9109 8.32736 4.90882 8.5677C4.90673 8.80805 4.99912 9.0396 5.1661 9.21249L10.3517 14.3981Z"
                      fill="#221F1F"
                    />
                  </svg>
                </label>
                <input
                  class="ais-dropdown-checkbox"
                  type="checkbox"
                  id="${facet.escapedName}"
                  name="dropdown"
                  ${checked}
                />
                <div class="ais-facet-${facet.escapedName}-container ais-facet-dropdown-container"></div>
              </div>
            `;
          })}

          <div class="ais-facets-mobile__footer">
            <button type="button" class="ais-facets-mobile__clear" data-ais-clear-facets>Clear All</button>
            <button type="button" class="ais-facets-mobile__apply" data-ais-mobile-drawer-close>Apply Filters</button>
          </div>
        </div>
        <div class="ais-block">
          <div class="ais-search-header">
            <div
              class="ais-stats-container ${hasBackToAllBooksLink
                ? 'ais-stats-container--with-back-to-all-books-link'
                : ''}"
            >
              ${this.backToAllBooksLinkTemplate(html)}
            </div>
            <div class="ais-change-display">
              <span class="ais-change-display-block ais-change-display-selected"><i class="fa fa-th-large"></i></span>
              <span class="ais-change-display-list"><i class="fa fa-th-list"></i></span>
            </div>
          </div>
          <div class="ais-hits-container ais-results-as-block"></div>
        </div>
        <div class="ais-pagination-container"></div>
      </div>
    `;

    return template;
  }

  instantSearchStatsTemplate(data) {
    let numberHits = Math.min(data.nbHits, this.config.resultsDisplayLimit).toLocaleString('en-US');

    if (data.nbHits > this.config.resultsDisplayLimit) {
      return `${numberHits}+ Books`;
    } else {
      return `${numberHits} Books`;
    }
  }

  instantSearchProductTemplate(hit, html, components) {
    hit = algoliaShopify.helpers.localizeHitData(hit);
    let title_overlay_div = ``;
    if (hit.image === null && hit.product_image === null) {
      title_overlay_div = html`<div
        class="title_overlay font-body-1"
        style="
        color: white;
        position: absolute;
        top: 55%;
        text-align: center;
        padding: 0 2rem;
        "
      >
        ${hit.title}
      </div>`;

      hit.image = 'https://allstora-assets-prod.s3.us-west-2.amazonaws.com/no_cover.png';
    }

    const productDetails = html`
      <div class="brand-product-tile__details">
        ${hit.product_type === 'FlaggedBook'
          ? html` <div
              class="brand-product-tile__member-price font-body-1"
              aria-label="${window.algoliaAllstora.translate['allstora.user.regular.price']}"
            >
              ${html`${this.renderPrice(hit, html)}`}
              <span aria-hidden="true"> ${window.algoliaAllstora.translate['allstora.user.regular.label']} </span>
            </div>`
          : html` <div
                class="brand-product-tile__member-price font-body-1"
                aria-label="${window.algoliaAllstora.translate['allstora.user.member.price']}"
              >
                ${html`${this.renderMemberPrice(hit, html)}`}
                <span aria-hidden="true"> ${window.algoliaAllstora.translate['allstora.user.member.label']} </span>
              </div>
              <div
                class="brand-product-tile__price font-body-1"
                aria-label="${window.algoliaAllstora.translate['allstora.user.regular.price']}"
              >
                ${html`${this.renderPrice(hit, html)}`}
                <span aria-hidden="true"> ${window.algoliaAllstora.translate['allstora.user.regular.label']} </span>
              </div>`}

        <div class="brand-product-tile__wishlist">
          <button
            type="button"
            class="wishlist-button swym-button swym-add-to-wishlist-view-product product_${hit.id} swym-icontext swym-heart swym-loaded"
            data-wishlist-button
            aria-label="Add to Wishlist"
            data-swaction="addToWishlist"
            data-with-epi="true"
            data-product-title="${hit.title}"
            data-product-id="${hit.id}"
            data-variant-id="${hit.objectID}"
            data-product-url="${window.algoliaAllstora.shopURL + algoliaShopify.helpers.instantsearchLink(hit)}"
            data-product-image="${algoliaShopify.helpers.sizedImage('1000x', hit)}"
          >
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M1.68292 9.62972C1.68292 5.12964 8.68292 1.12969 12.1829 7.62979C16.1829 1.12973 22.6829 5.44009 22.6829 9.62947C22.6829 16.1296 12.1829 21.6298 12.1829 21.6298C12.1829 21.6298 1.68292 16.6296 1.68292 9.62972Z"
                stroke="#221F1F"
                stroke-width="1.5"
                stroke-linejoin="round"
              ></path>
            </svg>
          </button>
        </div>
      </div>
    `;

    const template = html`
      <a class="brand-product-tile" href="${algoliaShopify.helpers.instantsearchLink(hit)}" aria-label="${hit.title}">
        <article class="brand-product-tile__content">
          <div class="brand-product-tile__badge-wrapper">${html`${this.renderBadge(hit, html)}`}</div>
          <div class="brand-product-tile__image-wrapper">
            <div class="brand-product-image">
              <img
                src="${algoliaShopify.helpers.sizedImage('960x', hit)}"
                alt=""
                width="306"
                height="462"
                class="brand-product-image__image brand-product-image__image--tall"
                loading="lazy"
              />
              ${title_overlay_div}
            </div>
          </div>
          ${window.Shopify.country !== 'US' ? '' : productDetails}
        </article>
      </a>
    `;

    return template;
  }
}

window.AllstoraAlgolia = new AllstoraAlgoliaClass();
